export default {"src":"/_next/static/media/code.81ed3091.svg","height":600,"width":927,"blurWidth":0,"blurHeight":0};